import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "48",
  height: "48",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m40-120 440-760 440 760zm104-60h672L480-760zm340.175-57q12.825 0 21.325-8.675t8.5-21.5-8.675-21.325-21.5-8.5-21.325 8.675-8.5 21.5 8.675 21.325 21.5 8.5M454-348h60v-224h-60zm26-122" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }